import { SelectPicker } from 'rsuite';
import { IOfferType, useOfferStore } from '../../../../store/offer-store';
import { useOfferFormContext } from '../../context';
import styles from './OfferTypeSelect.module.scss';

export const OfferTypeSelect = () => {
  const { offerTypes } = useOfferStore();
  const { offerType: offerTypeSelected, setOfferType: setOfferTypeSelected } = useOfferFormContext();

  return (
    <div className={styles.container}>
      <SelectPicker
        id="tipo-de-oferta-select"
        value={offerTypeSelected}
        onChange={setOfferTypeSelected}
        data={offerTypes}
        searchable={false}
        renderMenuItem={(_label, item: IOfferType) => (
          <div className={styles['render-menu-item']}>
            <span>{item.label}</span>
            <span className={styles['description']}>{item.description}</span>
          </div>
        )}
      />
    </div>
  );
};
